const e = {
  name: "ArrowCircleLeftFilled",
  dimensions: { width: 22, height: 22 },
  content: `
        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.31174e-07 11C5.87897e-08 17.07 4.93 22 11 22C17.07 22 22 17.07 22 11C22 4.93 17.07 2.03558e-07 11 1.31174e-07C4.93 5.87897e-08 2.03558e-07 4.93 1.31174e-07 11ZM11.71 6.29C11.91 6.49 12 6.74 12 7C12 7.26 11.9 7.51 11.71 7.71L9.42 10L15.01 10C15.56 10 16.01 10.45 16.01 11C16.01 11.55 15.56 12 15.01 12L9.42 12L11.71 14.29C12.1 14.68 12.1 15.31 11.71 15.7C11.32 16.09 10.69 16.09 10.3 15.7L6.3 11.7C6.21 11.61 6.13 11.5 6.08 11.37C5.98 11.13 5.98 10.85 6.08 10.61C6.13 10.49 6.2 10.38 6.3 10.28L10.3 6.28C10.69 5.89 11.32 5.89 11.71 6.28L11.71 6.29Z" fill="currentColor"/>
    `
};
export {
  e as ArrowCircleLeftFilled
};
